import { createTheme } from '@mui/material/styles';

// テーマの作成
export const theme = createTheme({
  typography: {
    fontFamily: [
      'Noto Sans JP',
      'sans-serif'
    ].join(','),
  },
});

// 共通のカラーコードを定義
export const colors = {
  mainColor: '#232e3e',
  backGroundColor: '#F6F6F6',
}
